var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { Emoji } from "emoji-mart";
import { Para } from "@irati/ui/src/Labels";
import Button from "@irati/ui/src/Button";
import { FormattedMessage } from "@irati/utils/lang";
import Card from "@irati/ui/src/Layout/Card";
import padding from "@irati/ui/src/global/padding";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), padding.small);
var InlinePara = styled(Para)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline;\n"], ["\n  display: inline;\n"])));
var MaxWidth = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 350px;\n"], ["\n  max-width: 350px;\n"])));
var StyledEmoji = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  .emoji-mart-emoji {\n    margin: 0 5px;\n    top: 5px;\n  }\n"], ["\n  .emoji-mart-emoji {\n    margin: 0 5px;\n    top: 5px;\n  }\n"])));
var MakeAClaim = /** @class */ (function (_super) {
    __extends(MakeAClaim, _super);
    function MakeAClaim() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isClicked: false
        };
        _this.handleClick = function () {
            _this.setState({ isClicked: true });
            _this.props.onClick();
        };
        return _this;
    }
    MakeAClaim.prototype.render = function () {
        var isClicked = this.state.isClicked;
        return isClicked ?
            React.createElement(Wrapper, null,
                React.createElement(Card, null,
                    React.createElement(MaxWidth, null,
                        React.createElement(InlinePara, { large: true, light: true },
                            React.createElement(FormattedMessage, { id: "medical.myMedical.accordionItem.makeAClaim.start" })),
                        React.createElement(StyledEmoji, null,
                            React.createElement(Emoji, { emoji: { id: "iphone" }, size: 20, set: "apple" })),
                        React.createElement(InlinePara, { large: true, blue: true },
                            React.createElement(FormattedMessage, { id: "medical.myMedical.accordionItem.makeAClaim.phoneNumber" })),
                        React.createElement(Wrapper, null,
                            React.createElement(Para, null,
                                React.createElement(FormattedMessage, { id: "medical.myMedical.accordionItem.makeAClaim.para" }),
                                React.createElement(FormattedMessage, { id: "medical.myMedical.accordionItem.makeAClaim.download" })))))) :
            React.createElement(Wrapper, null,
                React.createElement(Button, { primary: true, large: true, full: true, onClick: this.handleClick },
                    React.createElement(FormattedMessage, { id: "medical.myMedical.accordionItem.makeAClaim.button" })));
    };
    return MakeAClaim;
}(Component));
export default MakeAClaim;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
